import VanillaTilt from "vanilla-tilt";export default function initTiltAnimation(){const elements=document.querySelectorAll(".js-tilt");VanillaTilt.init(elements)}
